/*
 * Clickable machine diagram on "Bolter og foringer <model>" product pages.
 *
 * These products have one variant per position (option "Position", values like
 * "POS.11A (Bucket Cylinder)") and a numbered machine diagram as product image
 * (machine-diagram-1 … -11 and -13 … -16). This puts a tappable hotspot over every
 * printed number: tapping it selects that position in the variant picker, so
 * price, stock and the add-to-cart button update as if the pill was clicked.
 *
 * Hotspot coordinates are % of the image (x from left, y from top), measured from
 * the 3840×2560 originals. Diagrams 3 and 4 share the same label layout, as do the
 * skid-steer diagrams 13 and 14. A diagram that isn't listed gets no hotspots.
 */
(function () {
  if (window.PfPositionDiagram) return;

  var D34 = {
    '1': [59.7, 63.9], '2': [32.7, 40.4], '4': [59.6, 46.4], '5': [52.5, 14.9],
    '6': [83.4, 9.9], '7': [65.7, 38.5], '8': [86.7, 23.2], '9': [65.9, 53.0],
    '10': [66.7, 62.7], '11': [87.7, 53.0], '11A': [87.8, 43.3], '12': [88.2, 62.6],
    '13': [87.6, 33.4]
  };

  // Skid-steer loaders (track / wheel versions share the label positions)
  var D1314 = { '8': [66.5, 34.7], '10': [83.7, 69.8], '11A': [72.8, 45.6] };

  // Mini excavators with offset boom (8 = tracked, 9 = wheeled; same label layout)
  var D89 = {
    '0': [51.7, 90.0], '1': [58.8, 61.2], '2': [59.1, 42.6], '3': [59.1, 52.1],
    '4': [47.0, 17.6], '5': [57.4, 5.9], '6': [86.6, 6.0], '7': [67.8, 29.8],
    '8': [88.8, 22.6], '9': [67.0, 42.7], '10': [66.6, 52.1], '11': [88.8, 55.9],
    '11A': [88.8, 45.0], '12': [88.9, 67.2], '13': [88.9, 33.1], '15': [50.1, 8.8],
    '16': [64.7, 6.0], '17': [47.1, 27.0]
  };

  var DIAGRAMS = {
    '1': {
      '0': [15.3, 65.0], '1': [59.8, 66.7], '2': [60.3, 57.2], '3': [29.9, 37.2],
      '4': [63.2, 48.1], '5': [57.9, 21.1], '6': [82.4, 20.9], '7': [69.2, 43.8],
      '8': [86.0, 36.2], '9': [68.5, 56.6], '10': [68.2, 66.5], '11': [88.0, 65.9],
      '11A': [88.1, 56.4], '12': [88.0, 75.8], '13': [86.5, 46.2]
    },
    '2': {
      '0': [21.8, 54.0], '1': [56.6, 66.2], '2': [57.6, 56.6], '3': [27.9, 41.8],
      '4': [61.0, 45.0], '5': [55.1, 16.2], '6': [78.6, 10.3], '7': [68.1, 38.9],
      '8': [85.8, 31.6], '9': [67.2, 56.4], '10': [67.3, 66.4], '11': [85.9, 69.7],
      '11A': [86.0, 57.7], '12': [85.1, 80.8], '13': [85.9, 47.0]
    },
    '3': D34,
    '4': D34,
    '5': {
      '0': [20.9, 58.9], '1': [59.2, 61.3], '2': [59.3, 51.2], '3': [21.1, 47.3],
      '4': [62.2, 40.7], '5': [56.1, 10.6], '6': [83.4, 6.5], '7': [68.9, 33.0],
      '8': [87.3, 31.5], '9': [68.4, 55.0], '10': [68.4, 64.4], '11': [87.1, 69.5],
      '11A': [87.8, 58.9], '12': [85.5, 79.6], '13': [87.3, 45.7]
    },
    '7': {
      '0': [30.1, 29.0], '1': [56.1, 59.9], '2': [14.4, 54.5], '3': [55.1, 36.4],
      '4': [55.5, 45.1], '5': [44.9, 9.4], '6': [76.8, 9.9], '7': [61.1, 36.4],
      '8': [82.9, 23.2], '9': [62.0, 52.5], '10': [62.2, 63.8], '11': [87.3, 61.2],
      '11A': [86.7, 49.5], '12': [87.5, 72.7], '13': [84.8, 38.4], '15': [34.5, 19.4]
    },
    // Tracked excavator, short tail
    '6': {
      '0': [30.1, 29.0], '1': [57.7, 61.2], '2': [14.4, 55.4], '3': [55.9, 36.2],
      '4': [56.0, 45.1], '5': [45.4, 8.2], '6': [78.7, 8.1], '7': [62.3, 36.2],
      '8': [85.0, 22.6], '9': [64.0, 53.9], '10': [64.2, 65.9], '11': [87.7, 60.3],
      '11A': [87.8, 50.7], '12': [88.0, 70.2], '13': [86.5, 39.0], '15': [34.7, 18.7]
    },
    '8': D89,
    '9': D89,
    // Backhoe loader (digging arm + front loader)
    '10': {
      '6': [28.4, 11.8], '7': [32.6, 23.4], '8': [7.8, 26.9], '9': [7.7, 52.0],
      '10': [18.6, 88.6], '11': [7.6, 72.7], '11A': [7.7, 62.2], '12': [28.8, 88.6],
      '13': [12.6, 83.5], '20': [82.7, 51.0], '22': [75.5, 46.9]
    },
    // Wheel loader
    '11': { '8': [64.8, 31.8], '9': [74.5, 39.7], '10': [77.3, 90.7], '11': [82.1, 48.2], '12': [88.8, 57.3] },
    // Wheel loader (older model)
    '15': { '8': [62.4, 27.4], '9': [75.0, 34.5], '10': [77.4, 85.9], '11': [65.7, 85.9], '12': [90.7, 54.0] },
    '13': D1314,
    '14': D1314,
    // Track loader
    '16': { '10': [73.3, 91.5], '12': [68.9, 49.6] }
  };

  /* "POS.01 (Boom Cylinder)" → "1", "POS.11A (…)" → "11A", "POS.00" → "0" */
  function codeOf(value) {
    var m = String(value || '').match(/POS\.?\s*0*([0-9]+[A-Z]?)/i);
    if (m) return m[1].toUpperCase();
    return /POS\.?\s*0+\b/i.test(value) ? '0' : null;
  }

  /* "POS.06 (Arm Cylinder)" → "6 – Arm Cylinder"; no description → "Posisjon 6" */
  function labelOf(value) {
    var code = codeOf(value);
    if (!code) return String(value || '');
    var m = String(value).match(/\(([^)]+)\)/);
    return m ? code + ' – ' + m[1].trim() : 'Posisjon ' + code;
  }

  function init(sectionId, optionName) {
    var section = document.getElementById('MainProduct-' + sectionId);
    if (!section) return;

    var img = null, layout = null;
    section.querySelectorAll('.product__media img').forEach(function (el) {
      if (img) return;
      // whole number: "machine-diagram-13" must not be read as diagram 1
      var m = (el.currentSrc || el.src || '').match(/machine-diagram-(\d+)(?!\d)/);
      if (m && DIAGRAMS[m[1]]) { img = el; layout = DIAGRAMS[m[1]]; }
    });
    if (!img) return;

    var host = img.parentElement;
    if (host.querySelector('.pos-diagram')) return;

    /* Option inputs are re-rendered by Dawn after every change — always query fresh */
    function optionInputs() {
      var picker = section.querySelector('variant-selects');
      if (!picker) return [];
      return Array.prototype.filter.call(
        picker.querySelectorAll('input[type="radio"], select option'),
        function (el) {
          var group = el.tagName === 'OPTION' ? el.parentElement : el.closest('fieldset');
          var legend = group && (group.querySelector('legend') || group.previousElementSibling);
          var name = (el.name || (el.parentElement && el.parentElement.name) || '') + ' ' + (legend ? legend.textContent : '');
          return name.indexOf(optionName) !== -1;
        }
      );
    }

    function currentValue() {
      var sel = null;
      optionInputs().forEach(function (el) {
        if ((el.tagName === 'OPTION' && el.selected) || el.checked) sel = el.value;
      });
      return sel;
    }

    var overlay = document.createElement('div');
    overlay.className = 'pos-diagram';
    overlay.innerHTML = '<span class="pos-diagram__hint" aria-live="polite">Trykk på et nummer for å velge posisjon</span>';
    var hint = overlay.querySelector('.pos-diagram__hint');
    /* The hint explains the diagram until the customer picks a position once;
       after that it names the selected position instead. */
    var interacted = false;

    var available = {};
    optionInputs().forEach(function (el) {
      var c = codeOf(el.value);
      if (c) available[c] = el.value;
    });

    Object.keys(layout).forEach(function (code) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pos-diagram__spot';
      btn.style.left = layout[code][0] + '%';
      btn.style.top = layout[code][1] + '%';
      btn.textContent = code;
      btn.dataset.code = code;
      if (available[code]) {
        btn.setAttribute('aria-label', available[code]);
        btn.title = available[code];
      } else {
        btn.disabled = true;
        btn.classList.add('pos-diagram__spot--na');
        btn.setAttribute('aria-label', 'Posisjon ' + code + ' er ikke tilgjengelig for denne maskinen');
        btn.title = 'Ikke tilgjengelig for denne maskinen';
      }
      overlay.appendChild(btn);
    });

    host.appendChild(overlay);

    /* Line the overlay up with the drawn image (the gallery uses object-fit: contain) */
    function place() {
      var bw = host.clientWidth, bh = host.clientHeight;
      var ratio = (img.naturalWidth && img.naturalHeight) ? img.naturalWidth / img.naturalHeight : 1.5;
      var w = bw, h = bw / ratio;
      if (h > bh) { h = bh; w = bh * ratio; }
      overlay.style.width = w + 'px';
      overlay.style.height = h + 'px';
      overlay.style.left = (bw - w) / 2 + 'px';
      overlay.style.top = (bh - h) / 2 + 'px';
    }
    place();
    if (!img.complete) img.addEventListener('load', place, { once: true });
    if (window.ResizeObserver) new ResizeObserver(place).observe(host);
    else window.addEventListener('resize', place);

    function sync() {
      var value = currentValue();
      var code = codeOf(value);
      if (interacted && value) {
        hint.textContent = labelOf(value);
        hint.classList.add('pos-diagram__hint--selected');
      }
      overlay.querySelectorAll('.pos-diagram__spot').forEach(function (b) {
        var on = b.dataset.code === code;
        b.classList.toggle('pos-diagram__spot--active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    overlay.addEventListener('click', function (e) {
      var btn = e.target.closest('.pos-diagram__spot');
      if (!btn) return;
      /* Don't let the tap open the image zoom underneath */
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;

      var target = null;
      optionInputs().forEach(function (el) {
        if (!target && codeOf(el.value) === btn.dataset.code) target = el;
      });
      if (!target) return;
      interacted = true;

      var changes = target.tagName === 'OPTION' ? !target.selected : !target.checked;
      if (changes) {
        /* Tells product-info.js not to move focus to the option input after the
           variant re-renders (that would scroll the page down to the picker) */
        section.dataset.pfDiagramPick = '1';
        if (target.tagName === 'OPTION') {
          var select = target.parentElement;
          select.value = target.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          target.click();
        }
      }
      sync();
    });

    section.addEventListener('change', function (e) {
      /* Only position changes count — not e.g. the quantity field */
      if (e.target && e.target.closest && e.target.closest('variant-selects')) interacted = true;
      setTimeout(sync, 0);
    });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () { sync(); });
    }
    sync();
  }

  window.PfPositionDiagram = { init: init, codeOf: codeOf, labelOf: labelOf, diagrams: DIAGRAMS };
})();
